var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaceholderProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24Z",
    fill: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9999 9.85986C28.0112 9.85986 31.2631 12.9703 31.2631 16.8072C31.2631 20.6442 28.0112 23.7546 23.9999 23.7546C19.9886 23.7546 16.7367 20.6442 16.7367 16.8072C16.7367 12.9703 19.9886 9.85986 23.9999 9.85986ZM23.9991 26.745C15.4941 26.745 8.45285 33.0124 7.24194 41.1807C11.5672 45.4001 17.4799 47.9999 23.9997 47.9999C30.519 47.9999 36.4312 45.4005 40.7564 41.1816C39.5459 33.0129 32.5045 26.745 23.9991 26.745Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderProfile);
export default __webpack_public_path__ + "static/media/placeholder_profile.717a74604e06e9c1c50c81313d6c6c43.svg";
export { ForwardRef as ReactComponent };